import { render, staticRenderFns } from "./CentralConsultasAnalise.vue?vue&type=template&id=21b010d3&scoped=true"
import script from "./CentralConsultasAnalise.vue?vue&type=script&lang=js"
export * from "./CentralConsultasAnalise.vue?vue&type=script&lang=js"
import style0 from "./CentralConsultasAnalise.vue?vue&type=style&index=0&id=21b010d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b010d3",
  null
  
)

export default component.exports